import {
  anyOpen,
  initialOpenSections,
  openSection,
  setAllSections,
  toggleSection
} from '../openSections';

describe('openSections', () => {
  const UNIVERSAL = 'Universal Attributes';
  const PARKING = 'Parking Attributes';
  const OVERNIGHT = 'Overnight RV Parking Attributes';

  const sections = [
    { sectionTitle: UNIVERSAL },
    { sectionTitle: PARKING },
    { sectionTitle: OVERNIGHT }
  ];

  describe('initialOpenSections', () => {
    it('starts every section expanded', () => {
      expect(initialOpenSections(sections)).toEqual({
        [UNIVERSAL]: true,
        [PARKING]: true,
        [OVERNIGHT]: true
      });
    });

    it('returns nothing to open when there are no sections', () => {
      expect(initialOpenSections([])).toEqual({});
    });

    it('keeps sections that share a rootAttributeKey separate', () => {
      expect(Object.keys(initialOpenSections(sections))).toHaveLength(sections.length);
    });
  });

  describe('toggleSection', () => {
    it('collapses an expanded section without touching the others', () => {
      const result = toggleSection(initialOpenSections(sections), PARKING);

      expect(result).toEqual({
        [UNIVERSAL]: true,
        [PARKING]: false,
        [OVERNIGHT]: true
      });
    });

    it('leaves a section sharing the same rootAttributeKey expanded', () => {
      const result = toggleSection(initialOpenSections(sections), PARKING);

      expect(result[OVERNIGHT]).toBe(true);
    });

    it('expands a collapsed section', () => {
      const collapsed = setAllSections(initialOpenSections(sections), false);

      expect(toggleSection(collapsed, UNIVERSAL)[UNIVERSAL]).toBe(true);
    });

    it('expands a section it has never seen before', () => {
      expect(toggleSection({}, 'Awards')).toEqual({ Awards: true });
    });
  });

  describe('setAllSections', () => {
    it('collapses every section', () => {
      expect(setAllSections(initialOpenSections(sections), false)).toEqual({
        [UNIVERSAL]: false,
        [PARKING]: false,
        [OVERNIGHT]: false
      });
    });

    it('expands every section, including ones already expanded', () => {
      const mixed = toggleSection(initialOpenSections(sections), UNIVERSAL);

      expect(setAllSections(mixed, true)).toEqual({
        [UNIVERSAL]: true,
        [PARKING]: true,
        [OVERNIGHT]: true
      });
    });
  });

  describe('openSection', () => {
    it('expands a collapsed section so a search jump can reach its rows', () => {
      const collapsed = setAllSections(initialOpenSections(sections), false);

      expect(openSection(collapsed, PARKING)[PARKING]).toBe(true);
    });

    it('leaves the other sections collapsed', () => {
      const collapsed = setAllSections(initialOpenSections(sections), false);
      const opened = openSection(collapsed, PARKING);

      expect(opened[UNIVERSAL]).toBe(false);
      expect(opened[OVERNIGHT]).toBe(false);
    });

    it('returns the same object when the section is already open', () => {
      const open = initialOpenSections(sections);

      expect(openSection(open, PARKING)).toBe(open);
    });
  });

  describe('anyOpen', () => {
    it('is true while at least one section is expanded', () => {
      const mixed = toggleSection(initialOpenSections(sections), UNIVERSAL);

      expect(anyOpen(mixed)).toBe(true);
    });

    it('is false once every section is collapsed', () => {
      expect(anyOpen(setAllSections(initialOpenSections(sections), false))).toBe(false);
    });

    it('is false when there are no sections', () => {
      expect(anyOpen({})).toBe(false);
    });
  });
});
